<template>
  <div>
    <van-nav-bar
      title="订单"
      left-text="返回"

      left-arrow
      @click-left="onClickLeft"
    />

    <van-form @submit="onSubmit">
      <van-field v-model="inputtxt"  label="客户名称" />
      
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="getclients">搜索</van-button>
      </div>
    </van-form>


    <div style="overflow-y:scroll;height: 844px;">
      <van-cell-group inset style="margin-top:10px;" v-for="item in clients" :key="item.id" label-class="celllabel" >
        <van-cell :value="item.name" :title="item.type"/>
        <van-cell :value="item.phone" :title="item.lxr"/>
        <van-cell :value="item.send_type" :title="item.pay_type"/>
        <van-cell  :title="item.address"/>

        <!-- <van-cell :title=" '订单ID：'+item.id" :value="item.salername" />
        <van-cell :title="'客户：'+item.clientname" :value="'总价'+item.total_price"/> -->
      </van-cell-group>


    </div>


  </div>
</template>

<script>
  import * as Api from './api.js'
import { Toast } from 'vant';
  export default {
    name: 'RukuList',
    data () {
      return {
        value:'',
        clients:[],
        inputtxt:'',
        saler:'',
        salers:[]





      }
    },
    created() {
      this.$store.dispatch('getlocaluserinfo')
      //this.getsaler()
	  
      this.getclients()
    },
    methods:{
      // getsaler(){
      //   let query = {
      //     limit:999,
      //     status:1
      //   }
      //   Api.GetUserList(query).then(res=>{
      //     this.salers = res.data.data
      //   })
      // },


      getclients(){
        let query = {
          limit:999,
          saler:this.$store.state.userinfo.userId,
          name:this.inputtxt,
          ordering:'-id'
        }

        Api.getclients(query).then(res=>{
          this.clients = res.data.data
        })

      },
      onClickLeft(){
        this.$router.push({path:'/'})
      },

    }
  }

</script>

<style>
  .celllabel{
    width:100%
  }
</style>



// WEBPACK FOOTER //
// src/views/salerviews/clientview/index.vue